import { isDataKey, isGoal } from "@effektify/types";
import { isCmsTag, isMdTag } from "@effektify/types/guards";
import { mapRowToColumns } from "./data.js";
const EMPTY_DATASET = {
  columns: [],
  data: []
};
const isGoalsList = (goals) => Array.isArray(goals) && goals.every((goal) => isGoal(goal));
const createTitleTranslator = (t) => (title) => {
  if (title === void 0) {
    return void 0;
  }
  if (typeof title === "string") {
    return {
      text: t(title),
      help: null
    };
  }
  let help = null;
  if (title.help) {
    help = isCmsTag(title.help) ? title.help : t(title.help);
  }
  return {
    text: t(title.text),
    isMarkdown: isMdTag(title.text),
    help
  };
};
const getValueData = (dataSources, value) => {
  if (!isDataKey(value)) {
    return null;
  }
  const {
    key
  } = value;
  const sources = Object.keys(dataSources);
  if (sources.length === 1) {
    return mapRowToColumns(dataSources[sources[0]] ?? EMPTY_DATASET)[key];
  }
  const [dataKey, sourceKey] = key.split(".").reverse();
  if (!dataKey || !sourceKey || !(sourceKey in dataSources)) {
    return null;
  }
  const columns = mapRowToColumns(dataSources[sourceKey]);
  if (dataKey in columns) {
    return columns[dataKey];
  }
  return null;
};
const getChartData = (dataSources, chart) => {
  if (dataSources === null || Object.keys(dataSources).length === 0 || !chart) {
    return EMPTY_DATASET;
  }
  const sources = Object.keys(dataSources);
  let keyPair = [];
  if (sources.length === 1 && sources[0] && dataSources[sources[0]]) {
    return dataSources[sources[0]];
  }
  if (chart.type === "semi-circle") {
    keyPair = chart.data.key.split(".");
  }
  if (chart.type === "bar_chart" || chart.type === "line_chart" || chart.type === "mixed_chart" || chart.type === "pie_chart") {
    keyPair = chart.configuration.x.data.key.split(".");
  }
  if (keyPair.length <= 1 || !keyPair[0]) {
    return EMPTY_DATASET;
  }
  return dataSources[keyPair[0]] ?? EMPTY_DATASET;
};
const mapTrendsData = (dataSources, trends, t) => {
  const sources = Object.keys(dataSources);
  const defaultSource = sources[0];
  try {
    return trends.map((trend) => {
      const [dataKey, sourceKey = defaultSource] = trend.value.key.split(".").reverse();
      const [compDataKey, compSourceKey = defaultSource] = trend.comp.key.split(".").reverse();
      if (!sourceKey || !compSourceKey || !dataKey || !compDataKey) {
        return {
          label: t(trend.label),
          value: 0,
          comp: 0,
          desiredTrend: "positive"
        };
      }
      return {
        label: t(trend.label),
        value: mapRowToColumns(dataSources[sourceKey])?.[dataKey]?.value ?? 0,
        comp: mapRowToColumns(dataSources[compSourceKey])?.[compDataKey]?.value ?? 0,
        desiredTrend: trend.desired_trend ?? "positive"
      };
    });
  } catch {
    return [];
  }
};
export {
  createTitleTranslator,
  getChartData,
  getValueData,
  isGoalsList,
  mapTrendsData
};
